import { MenuItem, MenuItemProps } from '@mui/material'
import { createLink } from '@tanstack/react-router'

const InnerMenuItemLink: React.FC<
    React.PropsWithChildren<
        { ref: React.RefObject<HTMLAnchorElement> } & MenuItemProps
    >
> = ({ children, ref, ...props }) => (
    <MenuItem component={'a'} ref={ref} {...props}>
        {children}
    </MenuItem>
)

export const MenuItemLink = createLink(InnerMenuItemLink)
